import axios from 'axios'
import qs from 'qs'

export const bonusService = ({
  addBonusContent (token, elemObj) {
    var stringifiedObj = qs.stringify(elemObj)
    return axios.post('/api/Element/CreateBonus', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listBonusModules (token, courseMasterId) {
    return axios.get('api/module/ListBonusModules?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listNonAttachedBonusModules (token, courseMasterId) {
    return axios.get('/api/Module/ListNonAttachedBonusModules?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateBonusContent (token, elemObj) {
    var stringifiedObj = qs.stringify(elemObj)
    return axios.put('/api/Element/UpdateBonus', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  cutAndPasteBonusElements (token, objToPost) {
    var stringifiedObj = qs.stringify(objToPost)
    return axios.post('/api/ImportData/CopyBonusElements', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/bonus-service.js